module.exports = __webpack_public_path__ + "static/media/Item 9.47231d04.jpg";